import { arrow } from "@popperjs/core";
import $ from "jquery";
import slick from "slick-carousel";

$(document).ready(function () {
  if ($(".banner-slider").length) {
    $(".banner-slider").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4000,
      dots: false,
      arrows: true,
      fade: true,
      speed: 800,
    });
  }
  if ($(".products-slider .products ").length) {
    $(".products-slider .products").slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 3000,
      centerMode: false,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  }
});


